export default __webpack_public_path__ + "c55d94a248721abbd2205460c2ca9cea.svg";